import { Box, Typography } from '@mui/material';

interface Props {
  variant?: 'full' | 'mark' | 'inverse';
  size?: number;
  showWordmark?: boolean;
}

export default function Logo({ variant = 'full', size = 36, showWordmark = true }: Props) {
  const isInverse = variant === 'inverse';
  const fillBg = isInverse ? '#FFFFFF' : '#1E3A8A';
  const fillFlame = '#F59E0B';
  const fillBook = isInverse ? '#1E3A8A' : '#FFFFFF';
  const wordColor = isInverse ? '#FFFFFF' : '#0F172A';

  return (
    <Box display="flex" alignItems="center" gap={1.25}>
      <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="Baseras School logo">
        <rect x="2" y="2" width="60" height="60" rx="14" fill={fillBg} />
        {/* Open book */}
        <path
          d="M14 40 V22 L32 28 L50 22 V40 L32 46 Z"
          fill={fillBook}
          opacity="0.95"
        />
        <path d="M32 28 V46" stroke={fillBg} strokeWidth="1.4" />
        {/* Flame of knowledge */}
        <path
          d="M32 22 C 30 18 28 16 30 12 C 31 14 33 14 33 12 C 35 16 35 19 32 22 Z"
          fill={fillFlame}
        />
        {/* Subtle B mark */}
        <text
          x="32"
          y="42"
          textAnchor="middle"
          fontFamily="Inter, sans-serif"
          fontWeight="800"
          fontSize="14"
          fill={fillBg}
        >
          B
        </text>
      </svg>
      {showWordmark && variant !== 'mark' && (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1, color: wordColor }}>
            Baseras
          </Typography>
          <Typography variant="caption" sx={{ color: wordColor, opacity: 0.7, letterSpacing: 1, fontSize: 10 }}>
            SCHOOL
          </Typography>
        </Box>
      )}
    </Box>
  );
}
